
 function fetchDownloadsAjax(year) {
	$.ajax({
		async: true,
        type: 'POST',
		url: base_url + 'admin-ajax.php',
		dataType: "html",
		data: { 
			action  : 'get_ajax_posts',
			afp_nonce: afp_vars.afp_nonce,
			year	: year
		},
		success: function( response ) {
			// console.log( response );

			$( '.downloads-list' ).html( response ); 
		}
	}); 
	
 }


 function fetchPoliciesAjax(year) {
	$.ajax({
		async: true,
        type: 'POST',
		url: base_url + 'admin-ajax.php',
		dataType: "html",
		data: { 
			action  : 'get_ajax_policies',
			afp_nonce: afp_vars.afp_nonce,
			year	: year
		},
		success: function( response ) {
			// console.log( response );
			$( '.downloads-list' ).html( response ); 
		}
	}); 
	
 }
